import { styled } from '@mui/material/styles';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { pxToRem } from 'src/common/utils/fonts';

const LoadingOptionRoot = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  color: theme.palette.text.tertiary,
}));

export const LoadingOption = () => {
  const { t } = useTranslation();
  return (
    <LoadingOptionRoot>
      <Typography variant="text1" color="text.secondary">
        {t('common.loading')}...
      </Typography>
      <CircularProgress size={pxToRem(18)} color="inherit" />
    </LoadingOptionRoot>
  );
};
